import { getTemplate } from "../template-helper";

const COMPONENT_NAME = "z-password" ;

const TEMPLATE_ID = "component-"+COMPONENT_NAME+"-template" ;
const TEMPLATE_URL = "/static/libs/components/"+COMPONENT_NAME+".html" ;

export default function register(){
    getTemplate(TEMPLATE_ID, TEMPLATE_URL).then((template)=>{
        
        class PasswordComponent extends HTMLElement {
            constructor() {
                super();
                const clone = document.importNode(template.content, true);
                this.appendChild(clone);

                this.input = this.querySelector("input") ;
                
                this.currentValue = null ;
                this.value = this.getAttribute("value") ;
            }

            get value() {
                return this.currentValue ;
            }
            
            set value(value) {
                this.currentValue = value;
                if(this.getAttribute("value") !== this.currentValue){
                    this.setAttribute('value', this.currentValue);
                }
            }

            static get observedAttributes() {
                return ['value', 'readonly'];
            }

            attributeChangedCallback(name, oldValue, newValue) {
                switch (name) {
                    case 'value':
                        if(newValue !== this.currentValue){
                            this.value = newValue ;
                        }
                    break;
                    case 'readonly':
                    console.log(`readonly ? ${oldValue} ${newValue}!`);
                    break;
                }
            }

            select(){
                if(this.input && this.input.select){
                    this.input.select() ;
                }
            }
            focus(){
                if(this.input && this.input.focus){
                    this.input.focus() ;
                }
            }
            checkValidity(){
                if(this.input && this.input.checkValidity){
                    return this.input.checkValidity() ;
                }
                return true;
            }
            setCustomValidity(msg){
                this.customValidity = msg ;
                if(this.input){
                    this.input.setCustomValidity(msg) ;
                }
            }
        }
        customElements.define(COMPONENT_NAME, PasswordComponent);
    }).catch((err)=>{
        throw err ;
    }) ;
}
